<template>
  <div id="dashboard-property-alerts">
    <div id="alerts">
      <h1>Alerts</h1>
      <span v-if="!alerts">No Alerts</span>
      <div class="alerts">
        <div v-for="alert in alerts" :key="alert.id" class="alert">
          {{ alert.name }}<br />
          {{ alert.email }}<br />
          {{ alert.sms_number }}<br />
          <span v-if="alert.is_active">
            Receiving Alerts<br />
            <a href="#" @click.prevent="deleteForReal(alert.id)">Stop Alerts</a
            ><br />
          </span>
          <span v-else>
            Not Receiving Alerts<br />
            <a href="#" @click.prevent="deleteForReal(alert.id)">Start Alerts</a
            ><br />
          </span>
          <!-- <router-link :to="{path: '/console/dashboard/property/' + property_id +'/alertedit/' + alert.id}">Edit Alert</router-link><br> -->
        </div>
      </div>
      <!-- <div class="center-text">
        <router-link
          :to="{ name: 'propertyalertcreate', params: { id: property_id }}"
          tag="button"
          name="addProperty"
          class="button button-200">Create Alert</router-link>
      </div> -->
      <div class="center-text">
        <router-link
          to="/console/account/usercreate"
          tag="button"
          name="addProperty"
          class="button button-200"
          >Create User</router-link
        >
      </div>
      <v-dialog />
    </div>
  </div>
</template>

<script>
import api from "@/api/index";
const apiServicePropertyAlert = new api.APIServicePropertyAlert();

export default {
  name: "PropertyAlerts",
  data() {
    return {
      propertyID: this.$route.params.id,
      alerts: []
    };
  },
  created() {
    this.getAlerts();
  },
  methods: {
    getAlerts: function() {
      apiServicePropertyAlert.getPropertyAlerts(this.propertyID).then(data => {
        if (data) {
          this.alerts = data.data;
        }
      });
    },
    deleteForReal: function(alertID) {
      apiServicePropertyAlert
        .deleteAlert(this.propertyID, alertID)
        .then(data => {
          if (data) {
            this.alerts = data.data;
            this.getAlerts();
          }
        });
    }
    // deleteAlertShowDialog: function (alertID) {
    //   this.show(alertID);
    // },
    // show: function (alertID) {
    //   this.$modal.show('dialog', {
    //     title: 'Alert!',
    //     text: 'Do you want to delete this alert?',
    //     buttons: [
    //       {
    //         title: 'Yes',
    //         handler: () => { this.deleteForReal(alertID); }
    //       },
    //       {
    //         title: '', // Button title
    //         default: true, // Will be triggered by default if 'Enter' pressed.
    //         handler: () => {} // Button click handler
    //       },
    //       {
    //         title: 'No'
    //       }
    //     ]
    //   });
    // },
    // hide: function () {
    //   this.$modal.hide('dialog');
    // }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
  font-size: 24px;
}
h2 {
  font-size: 18px;
}
h3 {
  font-size: 18px;
  margin-bottom: 0;
}
#alerts {
  lost-utility: clearfix;
}
.alerts {
  width: 100%;
  lost-column: 1/1;
}
.alert {
  lost-column: 1/3;
  background: #d5e3f4;
  padding: 15px;
  border-radius: 4px;
  lost-utility: clearfix;
  margin-bottom: 20px;
}
@media (max-width: 800px) {
  .alert {
    lost-column: 1/2;
  }
}
@media (max-width: 640px) {
  .alert {
    lost-column: 1/1;
  }
}
</style>
